import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ToastCloseButton = ({ closeToast }) => (
  <IconButton style={{ color: "#fff" }} onClick={closeToast}>
    <CloseIcon />
  </IconButton>
);
